import dynamicBigScreenPage from './src/components/big-screen/index.vue';
import dynamicPage from './src/components/item-base/t_dialog.vue';
import conitem from './src/components/item-base/component_item.vue';

import { clearMenuComCache, formatDate } from './src/components/actionUtils/apiTools';
import { initWebSocket } from './src/components/actionUtils/wsUtil';
import { initProxyHost } from './src/utils/request/proxyRequest';
import { Icon } from 'tdesign-icons-vue-next';
let TIcon = Icon;

//api/user
import {
  getUserByuid,
  srvAutoLogin,
  srvLogin,
  srvModPwdByMailCode,
  srvRegisterByMailCode,
  srvSendMailCode,
  updateUserPass,
  updateUserInfo,
  getSetByKey,
  iamGetCaptcha,
} from './src/api/user';

const ApiUser = {
  srvAutoLogin,
  srvLogin,
  srvModPwdByMailCode,
  srvRegisterByMailCode,
  srvSendMailCode,
  getUserByuid,
  updateUserPass,
  updateUserInfo,
  getSetByKey,
  iamGetCaptcha
};

import { luatGetCaptcha, luatGenVcode, luatRegisterUser, luatResetPassword } from './src/api/luatUser';

const ApiUserLuat = { luatGetCaptcha, luatGenVcode, luatRegisterUser, luatResetPassword };

//store/modules
import { useBriefStore } from './src/store/modules/brief';

import { useSettingStore } from './src/store/modules/setting';
import { useTabsRouterStore } from './src/store/modules/tabs-router';
import { useUserStore } from './src/store/modules/user';


// const StoreModules = {
//     useBriefStore,

//     useSettingStore,
//     useTabsRouterStore,
//     useUserStore
// };

//H5
import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import h5con from './src/components/item-base/v_content.vue';

function initPinia() {
  const pinia = createPinia();
  pinia.use(createPersistedState());
  return pinia;
}

export {
  ApiUser,
  clearMenuComCache,
  conitem,
  dynamicBigScreenPage,
  dynamicPage,

  formatDate,
  h5con,
  initPinia,
  initWebSocket,
  initProxyHost,
  useBriefStore,

  useSettingStore,
  useTabsRouterStore,
  useUserStore,

  ApiUserLuat,
  TIcon
};
